// Keep browser challenges and server verification on the same free check level.
export const advisorBotIdOptions = { advancedOptions: { checkLevel: 'basic' } } as const

export const advisorBotIdRoute = { path: '/api/advisor', method: 'POST', ...advisorBotIdOptions }
